import React from 'react';
import { NavLink } from "react-router-dom";

export default function Menu(props) {
    const [topMenuOpened, setTopMenuOpened] = React.useState(false);
    const [winWidth, setWinWidth] = React.useState(window.innerWidth);
    function debounce(handRes, ms) {
        let timer
        return () => {
            clearTimeout(timer)
            timer = setTimeout(() => {
                timer = null;
                handRes.apply(this, arguments);
            }, ms)
        };
    }
    React.useEffect(() => {
        const debouncedHandleResize = debounce(function handleResize() {
            setWinWidth(window.innerWidth);
            ToggleMenu(false);
        }, 100)
        window.addEventListener('resize', debouncedHandleResize)
        return () => window.removeEventListener('resize', debouncedHandleResize);
    });
    return (
        <>
            <img className="hamburgerMenu" src={topMenuOpened ? '/Images/Site/Close.png' : '/Images/Site/HamburgerMenu.png'} alt={topMenuOpened ? 'Close' : 'Menu'} title={topMenuOpened ? 'Close' : 'Menu'} onClick={()=>ToggleMenu(!topMenuOpened)} />
            <menu className={topMenuOpened ? 'fadeIn' : (winWidth > 1000 ? 'descktop' : 'fadeOut')}>
                <li><NavLink onClick={LinkClicked} className={state => GetLinkClass(state)} to="/">Home</NavLink></li>
                <li><NavLink onClick={LinkClicked} className={state => GetLinkClass(state)} to="/AboutBarpazir">About Barpazir</NavLink></li>
                <li><NavLink onClick={LinkClicked} className={state => GetLinkClass(state)} to="/ContactUs">Contact us</NavLink></li>
            </menu>
        </>
    );
    function GetLinkClass(state) {
        return state.isActive ? 'selected' : '';
    }
    function LinkClicked() {
        ToggleMenu(false);
    }
    function ToggleMenu(value) {
        setTopMenuOpened(old => value);
        props.onToggled(value);
    }
}